<template>
    <div v-if="false"/>
</template>

<script>
import emitHooks from "@/mixins/emitHooks"
export default {
  mixins: [ emitHooks ]
}
</script>
